var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtl = function SvgAtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 72"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ATL_svg__a{fill:#0c1512}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.4 52h-13l.6-4.6h1.8c1 0 1.7-1.2 1.7-1.2l12.9-26.1h11.3l4.1 25.4s.2 1.9 1.7 1.9h1.3l-.7 4.6H23.5l.7-4.6c4.8 0 3.3-3.3 3.3-3.3H16.6s-2.3 3.3 2.5 3.3zm.3-12.6h8.2L25 25.8z",
    className: "ATL_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4 47.4h2.2c1.9 0 2.1-1.6 2.1-1.6l2.9-21h-2.2c-3.2 0-3.7 7.4-3.7 7.4h-5.2l1.7-12.1h29.9l-1.7 12.1h-5l.5-3.7s.4-3.7-2.1-3.7h-2.5s-2.7 19.9-2.8 20.6c0 .7-.3 2 1.6 2h2.2l-.7 4.6H41.7zM93 51.9H66.7l.6-4.5h1.6c2 0 2.1-1.7 2.1-1.7l2.7-19s.4-1.9-2.1-1.9h-1.1l.7-4.8h16.9l-.8 4.8h-1.9c-1.8 0-2 1.9-2 1.9l-2.9 20.7H85c4.4 0 4.5-6.2 4.5-6.2h5.1z",
    className: "ATL_svg__a"
  })));
};
export default SvgAtl;